// Mock data for BizSarthi website

export const companyBranding = {
  name: "BizSarthi",
  legalName: "BizSarthi Private Limited",
  cin: "U70200HR2026PTC149081",
  tagline: "The True Sarthi of Your Business",
  logo: "/bizsarthi-premium-logo.svg",
};

export const servicesData = [
  {
    id: 1,
    title: "Accounting & Bookkeeping Services",
    description:
      "Monthly financial records, electronic maintenance, compliance review support, and structured business reporting",
    icon: "BookOpen",
    features: [
      "Monthly Financial Records Preparation",
      "Electronic Record Maintenance",
      "Compliance Review Support",
      "Financial Record Review & Observations",
    ],
  },
  {
    id: 2,
    title: "GST Compliance Services",
    description:
      "Complete GST Registration, GST Filing Services, GST Return Filing, reconciliation, and annual returns management",
    icon: "FileText",
    features: [
      "GST Registration Online",
      "Monthly GST Compilation & Verification",
      "Vendor & Entry Updates",
      "GST Deposit Advisory",
      "GSTR Filing & Reconciliation",
      "Annual GST Filings (GSTR 9 & 9C)",
    ],
  },
  {
    id: 3,
    title: "Income Tax Filing Services",
    description:
      "Income Tax Return filing, tax planning, and management for all entity types",
    icon: "Calculator",
    features: [
      "Income Tax Return Filing",
      "Tax Planning & Management",
      "Advance Tax Assistance (Quarterly)",
      "Tax Computation & Advisory",
    ],
  },
  {
    id: 4,
    title: "TDS Compliance Services",
    description:
      "Complete TDS applicability check, filing, and statutory compliance support",
    icon: "Receipt",
    features: [
      "TDS Applicability Check",
      "Monthly TDS Filing & Deposit",
      "TDS & TCS Compliance (194Q, 206C)",
      "Tax Compliance Review Annexures",
    ],
  },
  {
    id: 5,
    title: "ROC Compliance",
    description:
      "Board meeting records, statutory registers, and comprehensive MCA filings for annual compliance services",
    icon: "Building2",
    features: [
      "Board & General Meeting Records",
      "Statutory Register Maintenance",
      "Director KYC Compliance",
      "Statutory Form Filing (DPT-3, AOC-4, MGT-7)",
    ],
  },
  {
    id: 6,
    title: "Business Compliance Review Services",
    description:
      "Statutory compliance reviews, income tax verification, and internal assessments for complete compliance support",
    icon: "Search",
    features: [
      "Statutory Compliance Reviews",
      "Income Tax Compliance Review",
      "Internal Compliance Review",
      "GST Compliance Review",
    ],
  },
];

export const registrationServices = [
  {
    id: 1,
    title: "Company Registration in India",
    icon: "Building",
    types: [
      "Private Limited Company",
      "Partnership Firm",
      "LLP Registration",
      "OPC Registration",
    ],
  },
  {
    id: 2,
    title: "GST & Business Registrations",
    icon: "FileCheck",
    types: [
      "GST Registration Online",
      "PF Registration",
      "ESI Registration",
      "Trade License Registration",
      "MSME Registration",
    ],
  },
  {
    id: 3,
    title: "Trademark & FSSAI",
    icon: "Award",
    types: ["Trademark Registration", "FSSAI License", "ISO Registration"],
  },
  {
    id: 4,
    title: "Professional Tax & Shop Act",
    icon: "Briefcase",
    types: [
      "Professional Tax Registration",
      "Shop and Establishment Registration",
    ],
  },
];

export const virtualOfficeServices = [
  {
    id: 1,
    title: "Virtual Office Address",
    description:
      "Professional business address for GST Registration and Company Registration with mail handling",
    icon: "MapPin",
    price: "Starting from ₹828/month",
    yearlyPrice: "₹9,936/year",
    originalPrice: "₹11,040",
    features: [
      "Business Address for GST & Company Registration",
      "Mail Handling & Forwarding",
      "Agreement & NOC Documents",
      "Electricity Bill & Utility Proof",
      "Temporary Signage Assurance",
    ],
  },
  {
    id: 2,
    title: "Advanced Virtual Office",
    description:
      "Complete Virtual Office for GST Registration with permanent signage and GST verification support",
    icon: "Building2",
    price: "Starting from ₹1,724/month",
    yearlyPrice: "₹20,690/year",
    originalPrice: "₹22,989",
    popular: true,
    features: [
      "All Virtual Address Features",
      "Permanent Nameboard (company name + GSTIN)",
      "Physical Storage for Books of Accounts",
      "On-Site Support During Field Visits",
      "Ideal for GST Verification and Departmental Review Requirements",
    ],
  },
  {
    id: 3,
    title: "Shared Desk Address",
    description:
      "Dedicated workspace with demarcated space for Virtual Office for Company Registration",
    icon: "Users",
    price: "Starting from ₹2,155/month",
    yearlyPrice: "₹25,865/year",
    originalPrice: "₹28,739",
    features: [
      "All Advanced Features",
      "Demarcated Space or Desk Number",
      "Premium Permanent Signage",
      "Cloud Storage for Books of Accounts",
      "Ideal for 2Cr+ Revenue Businesses",
    ],
  },
  {
    id: 4,
    title: "Dedicated Desk Address",
    description:
      "Exclusive desk with GST certificate display for established enterprises - Premium Virtual Office Services",
    icon: "Laptop",
    price: "Starting from ₹3,104/month",
    yearlyPrice: "₹37,250/year",
    originalPrice: "₹41,389",
    features: [
      "All Shared Desk Features",
      "Unique Desk Number",
      "GST Certificate on Desk",
      "Permanent Entry Signage",
      "Best for MNCs & 10Cr+ Revenue Firms",
    ],
  },
];

export const pricingTiers = [
  {
    value: "0-40L",
    label: "0 - 40 Lakhs",
    packages: {
      starter: {
        name: "Compliance Essentials",
        monthlyPrice: 2799,
        yearlyPrice: 30229,
        originalPrice: 33588,
        discount: 10,
        features: [
          "Monthly Bookkeeping & Bank Reconciliation",
          "GST Return Filing Support",
          "Standard Annual ITR Preparation",
          "Quarterly Compliance Snapshot",
        ],
      },
      business: {
        name: "Tax & Filing Desk",
        monthlyPrice: 3999,
        yearlyPrice: 43189,
        originalPrice: 47988,
        discount: 10,
        features: [
          "All Compliance Essentials Features",
          "TDS Return Support (Standard Scope)",
          "Quarterly Management Report",
          "Dedicated Relationship Manager",
          "Entity-wise Annual Filing Calendar",
          "LLP / Private Limited Compliance Review Support",
        ],
      },
      enterprise: {
        name: "Finance & Compliance Desk",
        monthlyPrice: 5999,
        yearlyPrice: 64789,
        originalPrice: 71988,
        discount: 10,
        features: [
          "All Tax & Filing Desk Features",
          "Monthly MIS & Management Dashboard",
          "Receivables, Payables & Cash Review",
          "Priority Compliance Support",
        ],
      },
    },
  },
  {
    value: "40-70L",
    label: "40 - 70 Lakhs",
    packages: {
      starter: {
        name: "Compliance Essentials",
        monthlyPrice: 3999,
        yearlyPrice: 43189,
        originalPrice: 47988,
        discount: 10,
        features: [
          "Monthly Bookkeeping & Bank Reconciliation",
          "GST Return Filing Support",
          "Standard Annual ITR Preparation",
          "Quarterly Compliance Snapshot",
        ],
      },
      business: {
        name: "Tax & Filing Desk",
        monthlyPrice: 5599,
        yearlyPrice: 60469,
        originalPrice: 67188,
        discount: 10,
        features: [
          "All Compliance Essentials Features",
          "TDS Return Support (Standard Scope)",
          "Quarterly Management Report",
          "Dedicated Relationship Manager",
          "Entity-wise Annual Filing Calendar",
          "LLP / Private Limited Compliance Review Support",
        ],
      },
      enterprise: {
        name: "Finance & Compliance Desk",
        monthlyPrice: 7999,
        yearlyPrice: 86389,
        originalPrice: 95988,
        discount: 10,
        features: [
          "All Tax & Filing Desk Features",
          "Monthly MIS & Management Dashboard",
          "Receivables, Payables & Cash Review",
          "Priority Compliance Support",
        ],
      },
    },
  },
  {
    value: "70-1CR",
    label: "70 Lakhs - 1 Crore",
    packages: {
      starter: {
        name: "Compliance Essentials",
        monthlyPrice: 5599,
        yearlyPrice: 60469,
        originalPrice: 67188,
        discount: 10,
        features: [
          "Monthly Bookkeeping & Bank Reconciliation",
          "GST Return Filing Support",
          "Standard Annual ITR Preparation",
          "Quarterly Compliance Snapshot",
        ],
      },
      business: {
        name: "Tax & Filing Desk",
        monthlyPrice: 7999,
        yearlyPrice: 86389,
        originalPrice: 95988,
        discount: 10,
        features: [
          "All Compliance Essentials Features",
          "TDS Return Support (Standard Scope)",
          "Quarterly Management Report",
          "Dedicated Relationship Manager",
          "Entity-wise Annual Filing Calendar",
          "LLP / Private Limited Compliance Review Support",
        ],
      },
      enterprise: {
        name: "Finance & Compliance Desk",
        monthlyPrice: 11199,
        yearlyPrice: 120949,
        originalPrice: 134388,
        discount: 10,
        features: [
          "All Tax & Filing Desk Features",
          "Monthly MIS & Management Dashboard",
          "Receivables, Payables & Cash Review",
          "Priority Compliance Support",
        ],
      },
    },
  },
  {
    value: "1CR+",
    label: "₹1–5 Crore · Reference Only",
    packages: {
      starter: {
        name: "Compliance Essentials",
        monthlyPrice: 7999,
        yearlyPrice: 86389,
        originalPrice: 95988,
        discount: 10,
        features: [
          "Reference Scope — Final Quote After Data Review",
          "Monthly Bookkeeping & Bank Reconciliation",
          "GST Return Filing Support",
          "Standard Annual ITR Preparation",
        ],
      },
      business: {
        name: "Tax & Filing Desk",
        monthlyPrice: 11199,
        yearlyPrice: 120949,
        originalPrice: 134388,
        discount: 10,
        features: [
          "All Compliance Essentials Features",
          "TDS Return Support (Standard Scope)",
          "Quarterly Management Report",
          "Dedicated Relationship Manager",
          "Entity-wise Annual Filing Calendar",
          "LLP / Private Limited Compliance Review Support",
        ],
      },
      enterprise: {
        name: "Finance & Compliance Desk",
        monthlyPrice: 15999,
        yearlyPrice: 172789,
        originalPrice: 191988,
        discount: 10,
        features: [
          "All Tax & Filing Desk Features",
          "Monthly MIS & Management Dashboard",
          "Receivables, Payables & Cash Review",
          "Priority Compliance Support",
        ],
      },
    },
  },
];

// Populate only with genuine, source-verifiable customer reviews.
export const googleReviews = [];

export const googleRating = {
  source: "Google Business Profile",
};

export const googleReviewLink = "https://share.google/9errd4fqHXwGrwjk6";

export const companyStats = [
  {
    value: "PAN India",
    label: "Service Support",
    icon: "MapPin",
  },
  {
    value: "GST & ROC",
    label: "Compliance Support",
    icon: "ShieldCheck",
  },
  {
    value: "Registered",
    label: "Private Limited Entity",
    icon: "Award",
  },
  {
    value: "Free",
    label: "Initial Consultation",
    icon: "MessageCircle",
  },
];

export const whyChooseUs = [
  {
    id: 1,
    title: "One-Stop Solution",
    description:
      "From GST registration to annual compliance review - all services under one trusted roof",
    icon: "Briefcase",
  },
  {
    id: 2,
    title: "Expert Team",
    description:
      "Qualified CAs and tax professionals with transparent, process-driven approach",
    icon: "Users",
  },
  {
    id: 3,
    title: "Tailored Plans",
    description:
      "Customized packages for every business size - pay only for what you need",
    icon: "Settings",
  },
  {
    id: 4,
    title: "Hassle-Free",
    description:
      "Dedicated relationship manager for timely filings and stress-free compliance",
    icon: "CheckCircle",
  },
  {
    id: 5,
    title: "Affordable Pricing",
    description:
      "Professional fees and known Government, portal or stamp charges shown separately",
    icon: "DollarSign",
  },
  {
    id: 6,
    title: "Timely Delivery",
    description:
      "24-48 hour response time with clear communication and regular updates",
    icon: "Clock",
  },
];

export const contactInfo = {
  email: "enquiry@bizsarthi.com",
  phone: "+91-7209119422",
  phone2: "+91-9220862108",
  whatsapp: "+91-9220862108",
  location:
    "C-78, 1st Floor, Ashok Vihar Phase-II, Rezang La Marg, Gurugram-122001",
  locationLink: "https://share.google/qKM7XbjeDItl4gb0s",
  managerName: "Radhe Shyam Jha",
  managerRole: "Co-Founder | Business Registration & Compliance Support",
};
